import styled from 'styled-components'
import { NextButton } from '../common/CommonStyled'
import AddIcon from '@mui/icons-material/Add';
import LeftTable from './LeftTable';
import { useModalStore } from 'src/stores/ModalStore';
import ModalTitleCreateTeam from './ModalTitleCreateTeam';
import ModalContentCreateTeam from './ModalContentCreateTeam';

const PageWrapper = styled.div`
    padding: 0px 11px;
    white-space: nowrap;
`
const LeftHeaderWrapper = styled.div`
    text-align: center;
    font-size: 32px;
    font-weight: 700;
    position: relative;
    padding: 28px;
    border-bottom: 1px solid #D1D1D1;
    line-height: normal;
    margin-bottom: 19px;
`
const LeftHeaderButtonWrapper = styled.div`
    position: absolute;
    right: 5px;
    top: 50%;
    transform: translateY(-50%);
    line-height: normal;
`

const LeftSection = () => {
    const modalSetField = useModalStore((state)=>state.setField)

    const onClickAddSchedule = ()=>{
        modalSetField('type','CENTER')
        modalSetField('width','812px')
        modalSetField('padding','30px')
        modalSetField('title', <ModalTitleCreateTeam/>)
        modalSetField('content',<ModalContentCreateTeam/>)
        modalSetField('open',true)
    }

  return (
    <PageWrapper>
        <LeftHeaderWrapper>
            팀 구성
            <LeftHeaderButtonWrapper>
                <NextButton style={{width:'112px',maxHeight:'44px', fontSize:'18px', fontWeight:500, gap:'8px'}} onClick={onClickAddSchedule}>
                    <AddIcon/> 팀 생성
                </NextButton>
            </LeftHeaderButtonWrapper>
        </LeftHeaderWrapper>
        <LeftTable/>
    </PageWrapper>
  )
}

export default LeftSection